import React from "react";
import { array, number, object, string } from "prop-types";

import Anchor from "../../../atoms/Anchor";
import CardImage from "../../../atoms/CardImage";
import NewsHeadline from "../../../atoms/NewsHeadline";
import PublishedAt from "../../../atoms/PublishedAt";

import "./visual-story-item.m.css";

const VisualStoryItem = ({ story, aspectRatio = [2, 3], index, imageType = "image2x3" }) => {
  if (!story) return null;

  const { headline, url, "story-template": type } = story;

  return (
    <Anchor
      styleName="visual-story-item"
      aria-label={headline}
      href={url + `?offset=${index}`}
      className="visual-story-item photo-story-card"
    >
      <CardImage
        className="card-with-image-zoom"
        styleName="image"
        story={story}
        aspectRatio={aspectRatio}
        imageType={imageType}
        widths={[200, 250, 350]}
      />
      <div styleName="bottom">
        <NewsHeadline
          showSubHeading={false}
          showSponsor={false}
          styleName="headline"
          story={story}
          linkEnable={false}
        />
        <PublishedAt date={story["last-published-at"]} styleName="time" />
        {type === "visual-story" && (
          <div styleName="bar">
            <span styleName="bar-item bar-active"></span>
            <span styleName="bar-item"></span>
            <span styleName="bar-item"></span>
            <span styleName="bar-item"></span>
            <span styleName="bar-item"></span>
          </div>
        )}
      </div>
    </Anchor>
  );
};

VisualStoryItem.propTypes = {
  story: object,
  imageType: string,
  aspectRatio: array,
  index: number,
};

export default VisualStoryItem;
